"use strict";
exports.__esModule = true;
var MESSAGE_SOUND_TYPES = {
    DEFAULT: {
        label: 'No',
        tooltip: '',
        type: 'no',
    },
    CUSTOM: {
        label: 'Custom',
        tooltip: '',
        type: 'custom',
    },
};
exports["default"] = MESSAGE_SOUND_TYPES;
